<script lang="ts" setup>
import type { IProps } from './TextInBox.types'

withDefaults(defineProps<IProps>(), {
  layout: 'default',
})
</script>

<template>
  <UiSection>
    <UiTextInBox
      :box="box"
      :layout="layout"
    />
  </UiSection>
</template>
